import React from "react";

function Header({ isAdmin }) {
  return (
    <div style={{ background: "#161b22", borderBottom: "1px solid #30363d", padding: "13px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 20 }}>⚾</span>
        <span style={{ color: "#e6edf3", fontSize: 15, fontWeight: 700 }}>Wiffle Ball League</span>
      </div>
      {isAdmin && (
        <span style={{ background: "#1f3d6e", color: "#79c0ff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>
          ADMIN
        </span>
      )}
    </div>
  );
}

export default Header;